import { IonCol, IonGrid, IonItem, IonLabel, IonRow } from '@ionic/react';
import { ReactElement, useMemo } from 'react';
import { useMeasure } from 'react-use';
import i18n from '../../../../../../../../i18n';
import { MultipassFormResetButton } from '../multipass-form-reset-button';
import { MultipassScheduleLegend } from '../multipass-schedule-legend';
import { MultipassScheduleTableEditView } from './multipass-schedule-table-edit-view';
import { MultipassScheduleTableViewProps } from './multipass-schedule-table.types';

const MultipassScheduleTableView = (
  props: MultipassScheduleTableViewProps
): ReactElement => {
  const [labelRef, labelDim] = useMeasure<HTMLIonLabelElement>();

  const scheduleColMarginLeft = useMemo(() => {
    if (labelDim.width) {
      return `calc(50% - ${labelDim.width / 2}px)`;
    }
    return '50%';
  }, [labelDim.width]);

  return (
    <>
      <IonItem
        lines="none"
        style={{
          fontWeight: 600,
        }}
        className="transparent-background"
      >
        <IonGrid className="ion-no-padding">
          <IonRow className="ion-align-items-center">
            <IonCol style={{ marginLeft: scheduleColMarginLeft, flexGrow: 0 }}>
              <IonLabel ref={labelRef}>{i18n.t('common:schedule')}</IonLabel>
            </IonCol>
            <IonCol
              style={{
                flexGrow: 0,
                marginLeft: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <MultipassFormResetButton />
              <MultipassScheduleLegend />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonItem>
      <MultipassScheduleTableEditView {...props} />
    </>
  );
};

export { MultipassScheduleTableView };
